import { forwardRef, type Ref, type SVGProps } from "react";
const IconArrowDownCircleOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M23.7 16.2a1 1 0 0 0-1.5 0L17 21.5V8a1 1 0 1 0-2 0v13.5l-5.2-5.3a1 1 0 0 0-1.5 0 1 1 0 0 0 0 1.5l6.9 7a1 1 0 0 0 .8.3 1.1 1.1 0 0 0 .8-.3l6.9-7a1 1 0 0 0 0-1.5" />
    <path d="M4 16a12 12 0 1 1 12 12A12 12 0 0 1 4 16m-2 0A14 14 0 1 0 16 2 14 14 0 0 0 2 16" />
  </svg>
);
const ForwardRef = forwardRef(IconArrowDownCircleOutlineSVG);
ForwardRef.displayName = "IconArrowDownCircleOutline";
export { ForwardRef as IconArrowDownCircleOutline };
